import { render, staticRenderFns } from "./PersonalArea.vue?vue&type=template&id=73c6e32c&"
import script from "./PersonalArea.js?vue&type=script&lang=js&"
export * from "./PersonalArea.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports